var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"permission"},[(_vm.hasPermission)?[(_vm.$route.meta.keepAlive)?_c('keep-alive',[_c('router-view')],1):_c('router-view')]:[_vm._m(0)]],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-permission"},[_c('img',{attrs:{"src":require("@/assets/no-permission.png")}}),_c('div',{staticClass:"muted"},[_vm._v("暂无权限")])])
}]

export { render, staticRenderFns }